export enum ReplenishForm {
  ReplenishOptions = 'tqQo',
  ReplenishToPercentOfPAR = 'kVzE',
  ReplenishToPAR = 'uKJS',
  ItemOptions = 'S18u',
  Percent = 'cW1j',
  SetAll = 'Y8oQ',
}
